import React, { Component } from 'react';



class Loader extends Component {
  
  constructor(props) {
    super(props);
    this.state = {
      label: props.label ?? 'Connecting with Stripe\nThis might take a moment',
      show: props.show,
    };
  }


  static getDerivedStateFromProps(props) {
    return {
      label: props.label ?? 'Connecting with Stripe\nThis might take a moment',
      show: props.show,
    }
  }


  render() {
    if(this.state.show) {
      return (
        <div className="loading">
          <div className="loader-box">
            <span className="loader"><span className="loader-inner"></span></span>
          </div>
          <p style={{whiteSpace: 'pre-wrap'}}>{this.state.label}</p>
        </div>
      )
    } else {
      return null
    }
  }
}


export default Loader;